import { Add } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Flyout from '@/components/common/Flyout';
import QrCodeView from '@/components/common/qr-code-view';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useUserInfo from '@/hooks/users/use-user-info';
import useUserQrCode from '@/hooks/users/use-user-qrcode';
import ROUTES from '@/routes';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function MyCodeFlyout({ open, onClose }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: qrcode, isLoading: isUserQrCodeLoading } = useUserQrCode();
  const { data: userInfo, isLoading: isUserInfoLoading } = useUserInfo();

  const isLoading = isUserInfoLoading || isUserQrCodeLoading;

  return (
    <Flyout
      show={open}
      shouldCloseOnInteraction={false}
      className='mx-0 !pb-safe-offset-0'
      onClose={() => onClose()}>
      <div className='relative flex w-full flex-col items-stretch justify-between gap-8 rounded-t bg-white px-5 pt-5 pb-safe-offset-8'>
        <h4 className='text-center text-xs font-bold'>{t('contact.scan-code.my-code')}</h4>

        <button
          type='button'
          className='btn btn-circle btn-ghost absolute right-0 top-0 size-14'
          onClick={() => onClose()}>
          <Add
            variant='Outline'
            size={20}
            className='rotate-45'
          />
        </button>

        <LoadingLayout
          className='aspect-square size-48'
          promise={isLoading}>
          {() =>
            qrcode ? (
              <QrCodeView
                data={qrcode}
                label={userInfo?.NickName}
                avatarUrl={userInfo?.HeadImg}
                subtitle={userInfo?.VChatID}
                onForward={(url) => {
                  navigate(
                    ROUTES.CONTACT.REQUEST.SCAN.$.SHARE.$buildPath({ relative: true, searchParams: { code: url } }),
                  );
                }}
              />
            ) : null
          }
        </LoadingLayout>
      </div>
    </Flyout>
  );
}
